import { ArrowOption } from '@ritabygglov/core';
import styled from 'styled-components';
import { Side } from '../../types';
import { LeftArrowIcon, RightArrowIcon } from '../Toolbar/SvgIcons';

const PropertyButton = styled.button<{ $isActive: boolean }>`
  background-color: ${(props) =>
    props.$isActive ? 'rgba(4, 109, 243, 1)' : 'transparent'};
  border: none;
  padding: 8px;
  gap: 8px;
  border-radius: 4px;
  border: 1px;
  opacity: 0px;
  border: 1px solid rgba(21, 36, 55, 0.05);

  &:hover {
    cursor: pointer;
  }
`;

const ArrowButton = ({
  isActive,
  isLeftSide,
  onClick,
}: {
  isActive: boolean;
  onClick: () => void;
  isLeftSide: boolean;
}) => {
  return (
    <PropertyButton
      onClick={onClick}
      data-testid={'arrow-btn'}
      $isActive={isActive}
      title={'Pil'}
    >
      {isLeftSide ? (
        <LeftArrowIcon color={'#152437'} isFill={isActive} />
      ) : (
        <RightArrowIcon color={'#152437'} isFill={isActive} />
      )}
    </PropertyButton>
  );
};

export interface ArrowSelectionProps {
  onSelectArrowOption: (side: Side, option: ArrowOption) => void;
  isLeftActive: boolean;
  isRightActive: boolean;
}

export const ArrowSelection = ({
  onSelectArrowOption,
  isLeftActive,
  isRightActive,
}: ArrowSelectionProps) => {
  return (
    <>
      <ArrowButton
        isActive={isRightActive}
        isLeftSide={true}
        onClick={() =>
          onSelectArrowOption(
            Side.right,
            isRightActive ? ArrowOption.none : ArrowOption.slim
          )
        }
      />
      <ArrowButton
        isActive={isLeftActive}
        isLeftSide={false}
        onClick={() =>
          onSelectArrowOption(
            Side.left,
            isLeftActive ? ArrowOption.none : ArrowOption.slim
          )
        }
      />
    </>
  );
};
